
import HTMLRenderer from './../../zviz2/zviz/renderers/html';

import Group from './../../zviz2/zviz/components/group';
import Link from './../../zviz2/zviz/components/link';


import Graph from './components/graph';
// import Tooltip from './../../components/elements/tooltip';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {getSizeWatcher} from './../../zviz2/zviz/environment/window';
import state from './../../zviz2/zviz/state';
import global from './../../zviz2/zviz/global';

let scripts = document.getElementsByTagName('script');
let scriptNode = document.currentScript || scripts[scripts.length - 1];

// idee:
/* 
properties: {
    namespace: null,
    name: 'a_unique_name_in_the_namespace'
}

children by default get the same namespace. If a new namespace is given it
will add to the existing: 'namespace1.namespace2'

getObjectsByName(name, namespace=null){
    // returns a list of object with the name in the current namespace
    // or the one provided
}

states kunnen global of met de namespace worden gebruikt.
state.get(namespace + '.tooltip');

maar hoe kun je terug naar de 'juiste' namespace laag...?

*/

class Component{

    constructor(settings={}){
        
        this.settings = extend(settings, {
            container: null,
            color: [50, 50, 50],
            language: 'english',
            data: {
                dimension: [''],
                unit: [''],
                x1: [],
                x2: [],
                y: []
            }
        });

        this.objects = [];

        let container = settings.container;
        if(container == null){
            container = scriptNode.parentNode;
        }else if(typeof container == 'string'){
            container = document.getElementById(container);
        }

        if(container.clientWidth > 0){
            this.init();
        }
    }

    reset(){
        this.remove();
        this.init();
    }


    init(){

        let settings = this.settings;

        this.objects = [];
        this.objects.push(getSizeWatcher());

        let svgId = 'svg_' + Math.round(9999999*Math.random());
        let Main = extend({
            uid: svgId,
            properties: {
                data: extend({
                    color: settings.color,
                    language: settings.language
                }, settings.data)
            }
        }, Graph);

        let Download = [];
        if(window.enableSvgDownload){
            Download = extend({
                properties: {
                    style: {
                        border: '1px solid #ccc',
                        borderRadius: '5px',
                        padding: '5px 10px'
                    },
                    attributes: {
                        href: '#'
                    },
                    content: 'Save SVG'
                },
                events: {
                    click: (event, ctrl) => {
                        event.preventDefault();
                        let c = ctrl.getByUid(svgId);
                        if(c.renderOutput && c.renderOutput.result){
                            document.getElementById('downloadSvgContent').value = c.parent.renderOutput.result.innerHTML;
                            document.getElementById('downloadSvg').submit();
                        }
                    }
                }
            }, Link);
        }

        let Blueprint = extend({
            children: [
                cloneObject(Main),
                Download
                // cloneObject(Tooltip)
            ],
            properties: {
                style: { 
                    position: 'relative'
                 }
            },
            listeners: [
            ]
        }, Group);

        let container = settings.container;
        if(container == null){
            container = scriptNode.parentNode;
        }else if(typeof container == 'string'){
            container = document.getElementById(container);
        }

        let renderer = new HTMLRenderer();
        renderer.setCanvas(container);
        renderer.start(Blueprint);

        this.objects.push(renderer);

    }

    remove(){
        for(let o of this.objects){
            if(! (o instanceof Function)){
                o.remove();
            }
        }
        delete this.objects;
    }

}    

export default Component;

